"use strict";
import React from "react";
import ReactDOM from "react-dom";
import "../formatters/general";
import FactorBrokersService from "./factor_brokers_service";
import TypeAhead from "./ui/type_ahead";
function debtorDisplay(debtor) {
  let html = debtor.name;
  const address = debtor.payment_address;
  const phone = debtor.external_data["Phone1"] || debtor.external_data["Phone2"];
  const dot = debtor.external_data["DotNo"];
  const mc = debtor.external_data["MotorCarrNo"];
  if (dot && mc) {
    html += "<br> DOT: " + dot + " MC: " + mc;
  } else if (dot) {
    html += "<br> DOT: " + dot;
  } else if (mc) {
    html += "<br> MC: " + mc;
  }
  if (phone) {
    html += "<br>" + phone;
  }
  if (address) {
    html += "<br>";
    if (address.address_line_1) {
      html += address.address_line_1 + " ";
    }
    if (address.city) {
      html += address.city;
      if (address.state) {
        html += ", " + address.state;
      }
    }
  }
  return html;
}
function selectAll(event) {
  event.target.select();
}
function search(props, term) {
  return FactorBrokersService.search(term, props.silo);
}
export default React.createClass({
  componentDidMount() {
    if (this.props.autoFocus) {
      const element = ReactDOM.findDOMNode(this);
      window.setTimeout(() => {
        element.focus();
        element.select();
      });
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      TypeAhead,
      {
        readOnly: this.props.readOnly,
        remoteSearch: (term) => search(this.props, term),
        display: debtorDisplay,
        placeHolder: "Debtor Name",
        className: "carrier-setter__typeahead",
        isDroppable: true,
        selectedItem: this.props.factorBroker,
        onSelectItem: this.props.onSelectDebtor,
        onClearSelectedItem: this.props.onClearDebtor,
        onFocus: selectAll
      }
    );
  }
});
